module.exports = __webpack_public_path__ + "assets/3d993282d3dbd668514d150e55d187fa.png";